import { useParams } from 'react-router-dom';
import Layout from '../../../Components/Layout/Layout';
import { Container, Spinner } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { BsCalendarCheckFill } from 'react-icons/bs';
import { FaUserTie } from 'react-icons/fa';
import { BiTimeFive } from 'react-icons/bi';
import { MdLocationPin } from 'react-icons/md';
import moment from 'moment';
import { imgUrl } from '../../../Helpers/Constant';
import { VisitorAuthContext } from '../../../Context/AuthContex/VisitorAuthContext';
import Toaster from '../../../Components/Toaster/Toaster';
import SingleEventSpeaker from './SingleEventSpeaker';
import { B2BAuthContext } from '../../../Context/AuthContex/B2BAuthContext';
import {
  useGetSingelEventDetails,
  useRegisteredSingleEventB2B,
  useRegisteredSingleEventVisitor,
} from '../apiEndpoins/eventApiEndpoints';

const SingleEvent = () => {
  const Toast = Toaster();
  const { visitorUser } = VisitorAuthContext();
  const {
    state: { b2bUser },
  } = B2BAuthContext();
  const { id } = useParams();
  const { data, isLoading } = useGetSingelEventDetails(Number(id));
  const { mutate: b2b, isPending: b2bPending } = useRegisteredSingleEventB2B();
  const { mutate, isPending } = useRegisteredSingleEventVisitor();

  const handelEventRegister = (id: number) => {
    if (b2bUser?.b2b_id) {
      b2b({ fair_event_id: id });
    } else if (visitorUser?.visitor_id) {
      mutate({ fair_event_id: id });
    } else {
      Toast.fire({
        icon: 'error',
        title: 'Please Signin First then do Register',
      });
    }
  };
  return (
    <>
      <Layout>
        <div>
          <Container>
            {isLoading ? (
              <div className='text-center'>
                <Spinner
                  variant='primary'
                  style={{ height: '50px', width: '50px' }}
                />
              </div>
            ) : (
              <div>
                <div className='events-matrix-content event-details-main-cs'>
                  <div className='events-title '>
                    <h1>{data?.data?.event_title}</h1>
                  </div>

                  <Row>
                    <Col xs={12} md={{ span: 7, order: 'first' }}>
                      <div className='divider d-none d-md-block'></div>
                      <div className='events-matrix-info mt-3 '>
                        <div className='w-50 w-sm-100'>
                          <ul>
                            <li>
                              <div className='info-icon'>
                                <BsCalendarCheckFill />
                              </div>
                              <div className='info-content'>
                                <span>Date </span>
                                <p>
                                  {moment(data?.data?.event_date).format(
                                    'MMM Do YY'
                                  )}
                                </p>
                              </div>
                            </li>
                            <li>
                              <div className='info-icon'>
                                <FaUserTie />
                              </div>
                              <div className='info-content'>
                                <span>Speakers </span>
                                <p>
                                  {data?.data?.event_total_speaker} Speaker(s)
                                </p>
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div className='w-50 w-sm-100'>
                          <ul>
                            <li>
                              <div className='info-icon'>
                                <BiTimeFive />
                              </div>
                              <div className='info-content'>
                                <span>Time </span>
                                <p>
                                  {' '}
                                  {moment(
                                    data?.data?.event_start_time,
                                    'HH:mm:ss'
                                  ).format('hh:mm A')}{' '}
                                  {data?.data?.event_end_time && (
                                    <>
                                      - {''}
                                      {moment(
                                        data?.data?.event_end_time,
                                        'HH:mm:ss'
                                      ).format('hh:mm A')}
                                    </>
                                  )}
                                </p>
                              </div>
                            </li>
                            <li>
                              <div className='info-icon'>
                                <MdLocationPin />
                              </div>
                              <div className='info-content'>
                                <span>Venue </span>
                                <p>{data?.data?.event_venu}</p>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div className='ceremony-footer'>
                        {b2bPending || isPending ? (
                          <button className='default-btn' disabled>
                            Loading
                            <Spinner
                              as='span'
                              animation='border'
                              size='sm'
                              role='status'
                              aria-hidden='true'
                            />
                          </button>
                        ) : (
                          <button
                            className='default-btn'
                            onClick={() =>
                              handelEventRegister(
                                data?.data?.event_id as number
                              )
                            }
                          >
                            Register Now
                          </button>
                        )}
                      </div>
                    </Col>
                    <Col
                      md={5}
                      xs={{ span: 12, order: 'first' }}
                      className='mt-3 mt-md-0'
                    >
                      <div>
                        <img
                          className='w-100'
                          src={`${imgUrl}/event_files/${data?.data?.event_photo}`}
                          alt=''
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className='events-matrix-content mt-1'>
                  <div className='events-title events-title-style-2 text-left'>
                    <h1>Details</h1>
                  </div>
                  <div className='events-title event-details-text text-align-justify'>
                    <p>{data?.data?.event_description}</p>
                  </div>
                </div>

                <div className='text-center'>
                  <h3>Speakers</h3>
                </div>

                <SingleEventSpeaker id={id} />
              </div>
            )}
          </Container>
        </div>
      </Layout>
    </>
  );
};

export default SingleEvent;
